import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col } from 'tea-component';
import { useIntl } from 'umi';
import BubbleCommon, {
  overviewKeywordTips,
} from '@/pages/opinion/components/BubbleCommon';
import { v4 as uuidv4 } from 'uuid';
import TopicCard from '@op/pages/Performance/components/TopicKeyword/TopicCard';
import KeywordCard from '@op/pages/Performance/components/TopicKeyword/KeywordCard';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

export default function TopicKeyword({
  filter,
  translateTopic,
  curFilter,
  channelOption,
  gameInfo,
  handleTopicTitleClick,
  handleKeywordTitleClick,
}: any) {
  const { formatMessage } = useIntl();
  const [clickInfo, setClickInfo] = useState({
    dataIndex: null,
    seriesIndex: null,
    seriesName: null,
    name: null,
    except_others: null,
    except_topic: null,
    translationData: null,
  });

  const uniqueId = useMemo(() => uuidv4(), [filter, curFilter]);

  const handleClickInfo = (params: any) => {
    buriedBtnPoint('KOOS_ClickTopic', params);
    setClickInfo(params);
  };

  const [keywordTipsVisible, setKeywordTipsVisible] = useState<boolean>(false);

  let localHasShowKeywordTips = false;

  try {
    localHasShowKeywordTips = Boolean(
      window.localStorage.getItem('topic-keyword-has-show-keyword'),
    );
  } catch { }

  const [hasShowKeywordTips, setHasShowKeywordTips] = useState(
    localHasShowKeywordTips,
  );

  useEffect(() => {
    if (filter?.language?.length > 0 && !hasShowKeywordTips) {
      setKeywordTipsVisible(true);
    }
  }, [filter]);

  const filterParams = useMemo(() => {
    let channelValue: { [key: string]: string } = {};
    if (channelOption === 'game_store') {
      channelValue = { channel_type: 'comments' };
    } else if (channelOption === 'social') {
      channelValue = { channel_type: channelOption };
    }
    return {
      ...filter,
      sentiment_type: curFilter,
      ...channelValue,
    };
  }, [filter, channelOption, curFilter]);

  const keywordFilter = useMemo(
    () => ({ ...filterParams, exclude_hashtag: true }),
    [filterParams],
  );

  return (
    <Row className="performance-topic-keyword-card">
      <Col span={12} className="dbo-performance-topic-card">
        <TopicCard
          filter={filterParams}
          curFilter={curFilter}
          translateTopic={translateTopic}
          handleClickInfo={handleClickInfo}
          {...(gameInfo ? { gameInfo } : {})}
          {...(handleTopicTitleClick ? { handleTitleOnClick: handleTopicTitleClick } : {})}
        // downloadFileName={'Key Opinions'}
        ></TopicCard>
      </Col>

      <Col span={12} className="dbo-performance-keyword-card">
        <KeywordCard
          key={uniqueId}
          filter={keywordFilter}
          curFilter={curFilter}
          clickInfo={clickInfo}
          hasKeywordDownPage={true}
          {...(gameInfo ? { gameInfo } : {})}
          {...(handleKeywordTitleClick ? { handleTitleOnClick: handleKeywordTitleClick } : {})}
          dealwithTimeLineParams={(params: any) => ({
            ...params,
            statistics_field: 'overview',
          })}
          title={
            <>
              <BubbleCommon
                escapeWithReference
                showIcon={false}
                hasCloseIcon
                tipsMap={overviewKeywordTips}
                placement="top"
                visible={keywordTipsVisible}
                handleCloseIconClick={(e: Event) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setKeywordTipsVisible(false);
                  setHasShowKeywordTips(true);
                  window.localStorage.setItem(
                    'topic-keyword-has-show-keyword',
                    'true',
                  );
                  return false;
                }}
              >
                {formatMessage({ id: 'Keyword' })}
                <BubbleCommon
                  showIcon={true}
                  tipsMap={keywordTipsVisible ? null : overviewKeywordTips}
                  placement="top"
                ></BubbleCommon>
              </BubbleCommon>
            </>
          }
        ></KeywordCard>
      </Col>
    </Row>
  );
}
